<template>
  <v-container fluid>
        <v-row>
            <v-col md="2" lg="2" offset style="margin-top:14px;background-color:rgba(255, 255, 255, 0.958163);text-align:center;border-bottom:solid 1px honeydew">
                <img src="../assets/ihx-logo.png" alt="" width="88" height="35">
            </v-col>
            <v-col md="10" lg="10" style="background: linear-gradient(90deg, rgba(108, 104, 255, 0.958163) 0%, rgba(66, 64, 198, 0.958163) 100%);">
                <div ref="logoutButton" style="padding-top:1.5%;margin-left:89%;cursor:pointer;" @click="showDropdown = !(showDropdown)">
                <v-icon dark large style="padding-right:5%;">
                    mdi-account-circle
                </v-icon>
                <span id="user-active">{{(usernameInfo.length > 6)?usernameInfo.substr(0,1).toUpperCase():usernameInfo.charAt(0).toUpperCase() + usernameInfo.slice(1)}}</span>
                <div class="drp-dwn" v-show="showDropdown">
                    <v-btn color="green" class="ma-2 white--text" type="submit" @click="doLogout">Logout</v-btn>
                </div>

                </div>
            </v-col>
            
        </v-row>

        <div style="margin-top:66.3px;width:100%;margin-left:84px;">
            <v-row dense>
                <v-col md="auto" lg="auto">
                    <v-img src="../assets/home_icon.svg" width="21px" style="margin-right:6px;float:left;cursor:pointer;" @click="goBack"></v-img>
                    <span id="home-id" @click="goBack">HOME</span> <span id="arrow-id">>></span> 
                </v-col>

                <v-col md="3" lg="3">
                    <v-img src="../assets/folder_icon.svg" width="16px" style="float:left;margin-right:5px;margin-top:0.5%;"></v-img>
                    <span id="header-id">COST OF CARE PREDICTION</span>
                </v-col>
            </v-row>
        </div>

        <hr style="border: 0.7px dashed #9F9DE0;left:6.08%;right:8.2%;position:absolute;margin-top:23px;">

        <!-- New Code Here-->

        <v-row style="margin-top:66.3px;width:100%;margin-left:84px;margin-bottom:1%;">
            <v-col md="8" lg="8">
                <v-row>
                    <v-col md="5" lg="5" v-for="data in columnData" :key="data.id">
                        <v-row noGutters>
                            <v-col md="4" lg="4" style="margin-top:0.6em;font-size:0.9em;">
                                {{data.label}}
                            </v-col>
                            <v-col md="6" lg="6">
                                <v-text-field
                                    id="userName"
                                    hide-details="auto"
                                    :disabled="(data.id==9)?true:disable_form"
                                    v-model="inputData.parent_id[data.id]"
                                    outlined
                                    class="input-btns-user"
                                    dense
                                    autocomplete="new-amount"
                                    :type="(data.inputType?data.inputType:'String')"
                                    :min="(data.inputType)?1:''"
                                    v-if="data.type == 'text'"
                                ></v-text-field>
                                <v-autocomplete
                                    v-model="inputData.parent_id[data.id]"
                                    v-if="data.type == 'dropdown'"
                                    dense
                                    height="auto"
                                    :items="data.items"
                                    :disabled="disable_form"
                                    flat
                                    outlined
                                    style="height:2.5em;"
                                >
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>

            <!-- <hr :class="'hr-class-long'"> -->

            <v-col md="4" lg="4" style="margin-left:-10%;background-color:#B8B8B8;">
                <span style="font-size:1.5em;display:block;text-align-last:center;">Predicted Approved Amount</span><br>
                <br>
                <span style="text-align-last:left;font-size:1em;">Range for the Predicted Approved Amount for the selected parameters is <span style="font-weight:bolder;">26500-27350</span></span>
            </v-col>
        </v-row>

        <v-btn width="6em" height="2em" color="#2E2BEB" @click="submitInput()" :disabled="requestSent" class="white--text" style="font-family: Open Sans;font-weight:bolder;font-size:1.1em;line-height:26px;margin-left:86px;margin-bottom:10%;">Submit</v-btn>

        <!-- End of New Code-->
      <!-- <v-footer dark padless style="display:block;margin:0;bottom:0;width:100%;background:linear-gradient(90deg, #2E2BE2 0%, #5BB4B8 100%);">
          <v-row style="padding:0%;">
            <v-col md="12" lg="12" class="foot-class-show" style="padding-bottom:0%;">
              ©2023, IHX Private Limited. All Rights Reserved.
            </v-col>
          
          </v-row>
      </v-footer>  -->
      <v-footer dark padless fixed height="45px" style="display:block;margin:0;bottom:0;width:100%;background:linear-gradient(90deg, #2E2BE2 0%, #5BB4B8 100%);">
          <v-row style="padding:0%;">
            <v-col md="12" lg="12" class="foot-class">
              ©2023, IHX Private Limited. All Rights Reserved.
            </v-col>
          </v-row>
      </v-footer> 
      
      <v-snackbar
        v-model="snackbar"
        >
        {{snacktext}}

        <template v-slot:action="{ attrs }">
            <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="snackbar = false"
            >
            Close
            </v-btn>
        </template>
      </v-snackbar> 
  </v-container>
</template>

<script>
const axios = require('axios').default;

export default {
  name: 'Encoder',
  components: {
  },
  created(){
    document.title = "IHX Demo App";
    if(this.$store.state.userInfo.length == 0)
        this.$router.push('/');
  },
  beforeDestroy () {
    document.removeEventListener('click',this.changeState)
  },
  mounted () {
        document.addEventListener('click',this.changeState);
          this.interval = setInterval(() => {
            if (this.cirValue >= 100) {
                return (this.cirValue = 0)
            }
            this.cirValue += 20
        }, 1000);
  },
  methods:{
      changeState(e){
            let logoutButtonArea = this.$refs.logoutButton;
            
            if (!logoutButtonArea.contains(e.target)) {
                this.showDropdown = false
            }
      },
      doLogout(){
        this.$store.commit('resetState');
        this.$router.push('/').catch((e)=>{console.log(e);});
      },
      goBack(){
          this.$router.push('/main');
      },
      async submitInput(){
            if(this.inputData.parent_id.length == 9 && !this.inputData.parent_id.includes(undefined)){
                //
                let reqObjectData = new Object();

                for (let index = 0; index < this.inputData.parent_id.length; index++) {
                    reqObjectData[this.columnMap[index].label] = this.inputData.parent_id[index];
                }

                let url = process.env.VUE_APP_NODE_URL+"/payableAPI";
                let reqObj = {inputValues : reqObjectData};
                let resp = await axios.post(url,reqObj);

                console.log(resp.data);
            }
            else{
                //
                let missing_names = []

                for (let index = 0; index < 10; index++) {
                    (this.inputData.parent_id[index] == undefined)?(missing_names.push(this.columnMap[index].name)):'';               
                }

                this.snackbar = true;
                this.snacktext = `Missing Value for Fields : ${missing_names.join()}`;
                this.inputData.parent_id = [];
            }

      },
  },
  data(){
      return {
          snackbar : false,
          snacktext : '',
          requestSent: false,
          showResults: false,
          loadingData: false,
          showDropdown: false,
          usernameInfo:this.$store.state.username,
          claimed_amt:'',
          formInput:{claimed_amt:null,room_type:null,age:null,los:null,city:null,provider:null,gender:null,ailment_grp:null,insurance:null,label_input:null},
          disable_form:false,
          inputData:{
            parent_id:[]
          },
          label_data:'',
          columnMap: {0:{name:"Claimed Amount",label:"ClaimedAmount"},1:{name:"Room Type",label:"RoomType"},2:{name:"Age",label:"Age"},3:{name:"Length of Stay",label:"LOS"},4:{name:"City",label:"HospCityName"},5:{name:"Provider",label:"ProviderId"},6:{name:"Gender",label:"Gender"},7:{name:"Ailment Group",label:"Ailment_Group"},8:{name:"Insurance",label:"InsuranceCompany"},9:{name:"Label for Input",label:false}}
      }
  },
  computed:{
      columnData(){
          return [
            {id:0,label:"Claimed Amount",type:"text"},
            {id:1,label:"Room Type",type:"dropdown",items:['General Ward (Economy Ward)','Day care','Single Ward ( Private / Special / Executive Ward)','Single Ward ( Private / Special / Executive Ward)','Isolation ward','Single Ward ( Private / Special / Executive Ward)','Day care','General Ward (Economy Ward)','Single Ward ( Private / Special / Executive Ward)','Single private room','Single Ward ( Private / Special / Executive Ward)','Deluxe (Luxury/ Super Deluxe / Suite / Ultra Special Ward)','Deluxe (Luxury/ Super Deluxe / Suite / Ultra Special Ward)','Single Ward ( Private / Special / Executive Ward)','Day care','General/Economy ward','Single Ward ( Private / Special / Executive Ward)','Semi private room','Deluxe room','Deluxe (Luxury/ Super Deluxe / Suite / Ultra Special Ward)','Day care','Day care','Single Ward ( Private / Special / Executive Ward)','Day care','ICU','Day care','Single private room','Single Ward ( Private / Special / Executive Ward)','Day care','Single Ward ( Private / Special / Executive Ward)','General Ward (Economy Ward)','Day care','Single private room','Day care','Day care','Day care','Single Ward ( Private / Special / Executive Ward)','Day care','Single Ward ( Private / Special / Executive Ward)','ICU','General Ward (Economy Ward)','Single Ward ( Private / Special / Executive Ward)','Day care','Single private room','Day care','Sharing Ward (Semiprivate / Multibed Ward)','Single Ward ( Private / Special / Executive Ward)','Single Ward ( Private / Special / Executive Ward)','"INTENSIVE CARE UNIT','(ICU/ICCU/CICU/MICU/NICU/NSICU/SICU/PICU/HDU)"','Single Ward ( Private / Special / Executive Ward)','GENERAL A/C','Single Ward ( Private / Special / Executive Ward)','Single Ward ( Private / Special / Executive Ward)','Single Ward ( Private / Special / Executive Ward)','Day care','Single Ward ( Private / Special / Executive Ward)','General Ward (Economy Ward)','Single Ward ( Private / Special / Executive Ward)','Day care','Single Ward ( Private / Special / Executive Ward)','Day care','General Ward (Economy Ward)','Single Ward ( Private / Special / Executive Ward)','"INTENSIVE CARE UNIT','(ICU/ICCU/CICU/MICU/NICU/NSICU/SICU/PICU/HDU)"','"INTENSIVE CARE UNIT','(ICU/ICCU/CICU/MICU/NICU/NSICU/SICU/PICU/HDU)"','Single Ward ( Private / Special / Executive Ward)','Day care','General/Economy ward','Day care','Single Ward ( Private / Special / Executive Ward)','Day care','General Ward (Economy Ward)','General Ward (Economy Ward)','Single Ward ( Private / Special / Executive Ward)','PVT A/C','Semi private room','Day care','General Ward (Economy Ward)','"INTENSIVE CARE UNIT','(ICU/ICCU/CICU/MICU/NICU/NSICU/SICU/PICU/HDU)"','Single Ward ( Private / Special / Executive Ward)','"INTENSIVE CARE UNIT','(ICU/ICCU/CICU/MICU/NICU/NSICU/SICU/PICU/HDU)"','Single Ward ( Private / Special / Executive Ward)','Day care','Day care','Single Ward ( Private / Special / Executive Ward)','General Ward (Economy Ward)','General Ward (Economy Ward)','Day care','Day care','General Ward (Economy Ward)','Day care','General Ward (Economy Ward)','Day care','General Ward (Economy Ward)','Day care','Day care','Single Ward ( Private / Special / Executive Ward)','Day care','Single Ward ( Private / Special / Executive Ward)','Day care','Single Ward ( Private / Special / Executive Ward)','Sharing Ward (Semiprivate / Multibed Ward)','Single Ward ( Private / Special / Executive Ward)','Day care']},
            {id:2,label:"Age",type:"text"},
            {id:3,label:"Length of Stay",type:"text",inputType:"number"},
            {id:4,label:"City",type:"dropdown",items:['Chennai','Tirunelveli','Muzaffarpur','Vijayawada','Panchkula','BARRACKPORE','Hyderabad','Noida','Mysore','Hyderabad','Thane','Hyderabad','Manjari','Ernakulam-Cochin','Ghaziabad','Indore','Bengaluru','Indore','Amaravati','Kanpur','Trichy','Pune','Kolkata','Pune','Nashik','Hyderabad','New Delhi','Chennai','Coimbatore','Ongole','Siliguri','Bengaluru','Gurgaon','Bengaluru','BARRACKPORE','Chennai','Erode','Bengaluru','Hyderabad','Hosur','Vellore','Kottayam','Indore','Bengaluru','Aurangabad','Kurnool','Kolkata','Kolkata','Mumbai','Patna','Kolkata','Raichur','Gurgaon','Ahmedabad','Chennai','Pune','Dharwad','Vishakapatanam','Ghaziabad','Anantapur','Varanasi','Chennai','New Panvel','Baramati','Bengaluru','Bareilly','Ernakulam-Cochin','Chennai','Ernakulam-Cochin','Bengaluru','Hyderabad','Nagpur','Calicut','Noida','New Delhi','Bengaluru','Hyderabad','Nadia','Ghaziabad','New Delhi','Thane','Indore','Hyderabad','Bengaluru','Jamshedpur','Manipal','Haldia','Vijayawada','Vishakapatanam','Bengaluru','New Delhi','New Delhi','Pune','Ghaziabad','Belgaum','Bengaluru','Kottayam','Pune','Bengaluru','Pune','Palwal','Cuttack','New Delhi','Calicut']},
            {id:5,label:"Provider",type:"dropdown",items:['514339','513809','514252','502825','505014','507957','507048','514823','505399','515671','512924','513193','509723','508938','513099','509301','508706','509318','509646','514383','508535','509634','512974','510022','511442','500914','500672','513025','513188','502583','515289','500344','500941','505671','507594','513138','507620','500776','506148','513397','514975','508980','509363','500350','516136','502476','508381','506455','500692','503187','507723','505423','505034','503934','500718','500816','505543','502967','513423','502595','507079','500718','510992','510177','507184','507246','508899','505964','508899','500351','515587','510529','509097','507089','503448','500344','512582','508375','515987','503486','516424','509366','515741','507984','500769','508845','507951','502392','502381','500866','503475','500782','500816','513423','505335','505883','508986','500837','516566','500816','504704','507922','503531','509097']},
            {id:6,label:"Gender",type:"dropdown",items:['M','F']},
            {id:7,label:"Ailment Group",type:"dropdown",items:['A90-A99','H25-H28','K80-K87','A90-A99','I70-I79','K35-K38','H25-H28','K20-K31','J30-J39','O80-O82','J60-J70','O80-O82','A90-A99','J20-J22','N17-N19','R50-R69','A00-A09','G35-G37','H25-H28','N80-N98','H25-H28','H25-H28','B15-B19','R50-R69','A30-A49','N17-N19','K80-K87','S50-S59','H25-H28','S00-S09','I60-I69','C15-C26','M65-M67','O80-O82','H25-H28','N17-N19','U00-U49','H25-H28','I80-I89','I20-I25','O80-O82','U00-U49','H25-H28','J09-J18','H25-H28','N17-N19','N80-N98','U00-U49','I20-I25','K50-K52','C51-C58','N20-N23','O80-O82','N20-N23','C50-C50','U00-U49','O80-O82','N20-N23','H25-H28','S30-S39','H25-H28','C30-C39','U00-U49','I60-I69','U00-U49','D10-D36','C50-C50','E08-E13','N17-N19','O80-O82','N17-N19','A00-A09','J09-J18','R50-R69','R50-R69','K55-K64','H25-H28','O80-O82','G89-G99','U00-U49','R50-R69','C00-C14','H25-H28','H49-H52','M65-M67','R00-R09','N30-N39','H25-H28','S50-S59','C40-C41','H25-H28','A90-A99','H25-H28','A90-A99','C51-C58','N17-N19','U00-U49','C50-C50','O80-O82','C81-C96','D10-D36','C50-C50','K40-K46','C30-C39']},
            {id:8,label:"Insurance",type:"dropdown",items:['The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','National Insurance Co. Ltd.','The New India Assurance Co. Ltd','United India Insurance Co. Ltd','The New India Assurance Co. Ltd','National Insurance Co. Ltd.','The Oriental Insurance Co. Ltd.','The Oriental Insurance Co. Ltd.','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','ManipalCigna Health Insurance Company Limited','National Insurance Co. Ltd.','The New India Assurance Co. Ltd','ManipalCigna Health Insurance Company Limited','United India Insurance Co. Ltd','The Oriental Insurance Co. Ltd.','ManipalCigna Health Insurance Company Limited','The Oriental Insurance Co. Ltd.','The New India Assurance Co. Ltd','The Oriental Insurance Co. Ltd.','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The Oriental Insurance Co. Ltd.','National Insurance Co. Ltd.','ICICI Lombard General Insurance Co. Ltd','The New India Assurance Co. Ltd','ICICI Lombard General Insurance Co. Ltd.','SBI General Insurance Company Limited','The Oriental Insurance Co. Ltd.','The New India Assurance Co. Ltd','The Oriental Insurance Co. Ltd.','The Oriental Insurance Co. Ltd.','The New India Assurance Co. Ltd','National Insurance Co. Ltd.','The Oriental Insurance Co. Ltd.','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','SBI General Insurance Company Limited','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The Oriental Insurance Co. Ltd.','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','SBI General Insurance Company Limited','The Oriental Insurance Co. Ltd.','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','United India Insurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','United India Insurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','ManipalCigna Health Insurance Company Limited','The Oriental Insurance Co. Ltd.','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','United India Insurance Co. Ltd','The Oriental Insurance Co. Ltd.','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','Reliance General Insurance Co. Ltd.','The New India Assurance Co. Ltd','Tata AIG General Insurance Company LTD','ManipalCigna Health Insurance Company Limited','The New India Assurance Co. Ltd','Reliance General Insurance Co. Ltd.','ManipalCigna Health Insurance Company Limited','The New India Assurance Co. Ltd','National Insurance Co. Ltd.','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','United India Insurance Co. Ltd','The New India Assurance Co. Ltd','National Insurance Co. Ltd.','The Oriental Insurance Co. Ltd.','The New India Assurance Co. Ltd','The New India Assurance Co. Ltd','ManipalCigna Health Insurance Company Limited','ManipalCigna Health Insurance Company Limited','The New India Assurance Co. Ltd','The Oriental Insurance Co. Ltd.','National Insurance Co. Ltd.']},
            {id:9,label:"Label for Input",type:"text"},
          ];
      },
  },
}
</script>

<style scoped>

#arrow-id{
    vertical-align:top;
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    align-items: center;
    text-transform: uppercase;
    margin-left:16px;
    margin-right:16px;
    color: #4B49C9;
}
#home-id{
    cursor:pointer;
    width: 59px;
    height: 22px;
    left: 111px;
    top: 130px;

    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 22px;
    /* identical to box height, or 110% */

    text-transform: uppercase;

    color: rgba(73, 70, 197, 0.53);
}
#header-id{
    width: 325px;
    height: 22px;
    left: 232px;
    top: 130px;

    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 19px;
    line-height: 22px;
    /* identical to box height, or 110% */

    text-transform: uppercase;

    color: #4946C5;
}
#new-sub-id{
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 22px;
    color: #4946C5;
}
#user-active{
    font-family: Open Sans;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
}
.foot-class{
    padding-bottom:0;
    /* padding:1%; */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    /* line-height: 22px; */
    margin-left:108px;
    margin-top:12px;
}
.hr-class-long{
  border:0.04em dashed #B6B6B6;
  transform:rotate(90deg);
  width:30rem;
  margin-left:45%;
  margin-top:18%;
  line-height:0px;
  position: absolute;
}
.foot-class-show{
    padding-bottom:0;
    /* padding:1%; */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    /* line-height: 22px; */
    margin-left:108px;
}
#table-headers-active{
    width: 137px;
    /* left: calc(50% - 137px/2 + 109.5px); */
    /* top: 40.68%; */
    /* bottom: 56.95%; */

    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 26px;
    /* identical to box height, or 186% */

    text-align: center;
    background-color: white;
    color: #2E2BEB;
    border: 1px solid #D3D3D3;
    border-bottom:none;
}
.drp-dwn{
    z-index: 10;
    position: absolute;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    background: #fff;
    border-radius:4%;
  }
#table-headers-inactive{
    width: 137px;
    /* left: calc(50% - 137px/2 + 109.5px); */
    /* top: 40.68%; */
    /* bottom: 56.95%; */

    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 26px;
    /* identical to box height, or 186% */
    text-align: center;
    color: rgba(75, 73, 201, 0.61);
    background-color: rgba(228, 228, 247, 0.33);
    border: 1px solid #D3D3D3;
    border-right:none;
    border-left:none;
}
#table-headers-inactive:hover{
    background-color: rgba(228, 228, 247, 0.33) !important;
}
#table-headers-active:hover{
    background-color: transparent !important;
}
</style>
